import React, { useContext, useState, useEffect } from 'react'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { SubCategoryContext } from '../../context api/SubCategory/SubCategoryContext'
import {useSalesChannelType} from '../../hooks/CompanyConfiguration/useSalesChannelType'
import { useCategory } from '../../hooks/Features/useCategory'
import { useProduct } from '../../hooks/Features/useProduct'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useTax } from '../../hooks/CompanyConfiguration/useTax'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useChannelType } from '../../hooks/CompanyConfiguration/useChannelType'
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core'
import CustomButton from '../../components/CustomButton'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTable from '../../components/Table/CustomTable'
import { sortByName } from '../../shared/constants'
import useValidation from '../../hooks/Validation/useValidation'

import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { toastMessage } from '../../shared/AlertPopup'

export default function TmpOrderForm({ handleOrderSubmit, orders, state, setState, setOrders, edit = false, setPrice }) {
    
  const { channelName, channelType, category, subCategory, product,  sku, qty, price, code} = state
  const { getAllsubCategoryByCategory } = useFeatures()
  const { getAllCategories, getCategory, category: ct } = useCategory()
  const {getAllChannelType}  = useChannelType();
  const { getAllProducts, product : prd, getProduct, getAllSecondaryVariant, allSecondaryVariant } = useProduct()
  const { getAllTax } = useTax()
  const { categories } = useContext(CategoryContext)
  const { channelTypes } = useContext(ConfigurationContext)
  const { subcategories } = useContext(SubCategoryContext)
  const {products} = useContext(ProductContext)
  const [visible, setVisible] = useState(true)
  const tableHeadings=['Code', 'Quantity', 'Sku', 'Price', 'Category', 'SubCategory', 'Channel Type', 'Sales Channel Type']

  const { salesChannelTypes } = useContext(ConfigurationContext)
  const { getAllSalesChannelType, deleteSalesChannelType, deleteManySalesChannelType, BulkUpload, loading, paginate } = useSalesChannelType()

  const [searchQuery, setSearchQuery] = useState('')

  const filterSalesChannelType = salesChannelTypes
    ? salesChannelTypes.filter((salesChannelType) => salesChannelType && salesChannelType.name && salesChannelType.name.toLowerCase().includes(searchQuery.toLowerCase()))
    : []

  useEffect(() => {}, [orders])
  useEffect(() => {
    if (category) {
      getAllsubCategoryByCategory({ categoryId: category._id })
    }
  }, [category])

  useEffect(() => {
    if(channelType){
      getAllSalesChannelType({ page: 1, channelType: channelType._id})
    }
    if (category && subCategory) {
      // getAllSecondaryVariant({ categoryId: category, subCategoryId: subCategory })
      getAllProducts({ categoryId: category._id, subCategoryId: subCategory._id })
      console.log(products);
    }
  }, [category, subCategory, channelType])

  useEffect(() => {
    getAllCategories()
    getAllChannelType()
  }, [])

  useEffect(() => {
    if(product && qty){
      setState({...state, price: prd?.dealerPrice * qty});
    }
    setPrice((price)=>{ return price+ prd?.dealerPrice * qty});
    console.log(qty);
  }, [qty])

  useEffect(() => {
    if(product)
    getProduct({productId: product})
  }, [product])


  const input1 = [
    {
      label: 'Select Channel Type',
      value: channelType,
      completeOption: true,
      name: 'channelType',
      fieldName: 'name',
      // fieldValue: '_id',
      options: channelTypes,
    },
    {
      label: 'Sales Channel Name',
      value: channelName,
      completeOption: true,
      name: 'channelName',
      fieldName: 'name',
      // fieldValue: '_id',
      options: salesChannelTypes,
    },
    {
      label: 'Code',
      value: code,
      name: 'code',
    }, 
  ]

  const input2= [
    {
      label: 'Select Category',
      value: category,
      completeOption: true,
      name: 'category',
      fieldName: 'categoryName',
      // fieldValue: '_id',
      options: sortByName(categories, 'categoryName'),
    },
    { 
      label: 'Select Sub Category',
      value: subCategory,
      completeOption: true,
      name: 'subCategory',
      fieldName: 'name',
      // fieldValue: '_id',
      options: sortByName(subcategories),
    },
    {
      label: 'Select Product',
      value: product,
      completeOption: true,
      name: 'product',
      fieldName: 'sku',
      // fieldValue: '_id',
      options: products,
    },
    {
      label: 'Quantity',
      value: qty,
      name: 'qty',
      type: 'NUMBER',
    },
  ]

  console.log(state)
  return <>
  {visible ? 
    <>
      {
      <>
      <CustomAddForm state={state} setState={setState} data={input1} />
      <br/>
      <br/>
      </>}
      
      <CustomButton
          handleSubmit={
            ()=> {
              setVisible(false)}
          }
          text={"Proceed"}
          noWidth
        />
    </>
    :
    <>
      {<CustomAddForm state={state} setState={setState} data={input2} />}
      <br/>
      <div style = {{fontWeight: "600", fontSize: "14px", marginTop: "15px", right: "0px", alignContent: "right"}}>
        Currend Order Price: &nbsp;
          {(prd!= '' && qty!= '' )? prd?.dealerPrice * qty: "Select Product and Quantity"}
      </div>
    </>
  }
    <br/>
    <br/>
     

  </>
}
